"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_sha3_1 = require("js-sha3");
var NamingService_1 = __importDefault(require("./NamingService"));
var resolutionError_1 = __importStar(require("./errors/resolutionError"));
var utils_1 = require("./utils");
var contract_1 = __importDefault(require("./utils/contract"));
var EthereumNamingService = /** @class */ (function (_super) {
    __extends(EthereumNamingService, _super);
    function EthereumNamingService(source, name) {
        if (source === void 0) { source = {}; }
        var _this = _super.call(this, source, name) || this;
        if (_this.registryAddress) {
            _this.readerContract = _this.buildContract(_this.readerAbi(), _this.registryAddress);
        }
        return _this;
    }
    EthereumNamingService.prototype.networkFromUrl = function (url) {
        if (!url) {
            return undefined;
        }
        for (var key in EthereumNamingService.NetworkNameMap) {
            // eslint-disable-next-line no-prototype-builtins
            if (!EthereumNamingService.NetworkNameMap.hasOwnProperty(key)) {
                continue;
            }
            if (url.indexOf(key) >= 0) {
                return EthereumNamingService.NetworkNameMap[key];
            }
        }
        return undefined;
    };
    EthereumNamingService.prototype.normalizeSource = function (source) {
        source = __assign({}, source);
        source.network =
            typeof source.network == 'string'
                ? EthereumNamingService.NetworkNameMap[source.network]
                : source.network || this.networkFromUrl(source.url) || 1;
        if (!source.provider && !source.url) {
            source.url = source.network
                ? this.urlMap()[source.network]
                : undefined;
        }
        source.registry = source.registry
            ? source.registry
            : this.defaultRegistry(source.network);
        return source;
    };
    EthereumNamingService.prototype.isSupportedNetwork = function () {
        return this.registryAddress != null;
    };
    EthereumNamingService.prototype.childhash = function (parent, label) {
        parent = parent.replace(/^0x/, '');
        var childHash = js_sha3_1.keccak_256(label);
        // eslint-disable-next-line no-undef
        return js_sha3_1.keccak_256(Buffer.from(parent + childHash, 'hex'));
    };
    EthereumNamingService.prototype.callMethod = function (contract, method, params) {
        return __awaiter(this, void 0, void 0, function () {
            var result, error_1, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, contract.call(method, params)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result[0]];
                    case 2:
                        error_1 = _a.sent();
                        message = error_1.message;
                        if (message.match(/Invalid JSON RPC response/) ||
                            message.match(/legacy access request rate exceeded/)) {
                            throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.NamingServiceDown, {
                                method: this.name,
                            });
                        }
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EthereumNamingService.prototype.buildContract = function (abi, address) {
        return new contract_1.default(abi, address, this.provider);
    };
    EthereumNamingService.prototype.throwOwnershipError = function (domain, ownerPromise) {
        return __awaiter(this, void 0, void 0, function () {
            var owner, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!ownerPromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, ownerPromise];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.owner(domain)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        owner = _a;
                        if (utils_1.isNullAddress(owner)) {
                            throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.UnregisteredDomain, {
                                domain: domain,
                            });
                        }
                        throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.UnspecifiedResolver, {
                            domain: domain,
                        });
                }
            });
        });
    };
    EthereumNamingService.NetworkNameMap = {
        mainnet: 1,
        ropsten: 3,
        rinkeby: 4,
        goerli: 5,
        kovan: 42,
    };
    EthereumNamingService.NetworkIdMap = utils_1.invert(EthereumNamingService.NetworkNameMap);
    return EthereumNamingService;
}(NamingService_1.default));
exports.EthereumNamingService = EthereumNamingService;
